export const parseOrderDirQueryParam = (orderDir: string | undefined): 'asc' | 'desc' => {
  if (!orderDir) {
    return 'asc';
  }
  const lowerCaseDir = orderDir.toLocaleLowerCase();
  if (lowerCaseDir !== 'asc' && lowerCaseDir !== 'desc') {
    return 'asc';
  }
  return lowerCaseDir;
};
